module.exports = __webpack_public_path__ + "static/media/home-logo.1aea7f40.svg";